import { useAppDispatch, useAppSelector } from 'src/hooks';
import React, { useState, useEffect, useRef } from 'react';
import './table-columns.scss';
import _ from 'lodash';
import { TableComponent, Header } from '../../types/generic-table.model';
import { handleNumericInputValueChange } from '../../../common/features/table/store/table-slice';
import { handleNumericInputValueChange as handleNumericInputValueChange2 } from '../../../common/features/table/store/table-slice2';

export default function PercentageInputBox({
  row,
  columnMetadata,
  uniqueIDColumns,
  componentType = TableComponent.PRICING,
  inputsDisabled = false
}: {
  row: any;
  columnMetadata: Header;
  uniqueIDColumns: Header[];
  componentType: TableComponent;
  inputsDisabled: boolean;
}) {
  const appDispatch = useAppDispatch();
  const { kpiSelection, toggle2 } = useAppSelector(
    (state) => state.pricingSimulator
  );
  // eslint-disable-next-line prefer-regex-literals
  const regexForDecimal = new RegExp('[0]+$', 'g');
  const decimalRegexData = regexForDecimal.exec(
    columnMetadata.parent.number_format
  );
  let splittedDecimalData = null;
  if (decimalRegexData && columnMetadata.parent.number_format.includes('0.')) {
    // eslint-disable-next-line prefer-destructuring
    splittedDecimalData = columnMetadata.parent.number_format.split('.')[1];
  }

  //Formating value
  const getFormattedValue = (selectedValue: number) => {
    const safeValue = typeof selectedValue === 'number' ? selectedValue : 0; // default to 0 if undefined
    if (columnMetadata.parent.number_format.includes('0.')) {
      return Number(safeValue.toFixed(2));
    }
    if (columnMetadata.parent.number_format === '#,###,##0') {
      return Number(Math.round(safeValue).toFixed(2));
    }
    return Number(safeValue.toFixed(2));
  };

  const [value, setValue] = useState<number | string>(() =>
    getFormattedValue(row.original[columnMetadata.parent.parent_field])
  );

  const previousValueRef = useRef<number>();
  const previousValue = previousValueRef.current;
  if (
    getFormattedValue(row.original[columnMetadata.parent.parent_field]) !==
      previousValue &&
    getFormattedValue(row.original[columnMetadata.parent.parent_field]) !==
      value
  ) {
    setValue(
      getFormattedValue(row.original[columnMetadata.parent.parent_field])
    );
  }

  const getSuffix = () => {
    if (
      columnMetadata.parent.field_format === 'PERCENTAGE' &&
      (row.original[columnMetadata.parent.prefix_label] !== null ||
        row.original[columnMetadata.parent.prefix_label] !== 'NAN' ||
        row.original[columnMetadata.parent.prefix_label] !== undefined)
    ) {
      return '%';
    }
    return '';
  };

  const handleValueChange: React.FocusEventHandler<HTMLInputElement> = (e) => {
    setValue(Number(e.target.value));
  };

  const handleValueChangenew: React.FocusEventHandler<HTMLInputElement> = (
    e
  ) => {
    const inputValue = e.target.value;

    // Allow empty input, which we will handle on blur
    if (inputValue === '' || inputValue === '-') {
      setValue(inputValue);
      return;
    }

    // Allow only numeric input including negative numbers
    const numericValue = Number(inputValue);
    if (!isNaN(numericValue)) {
      setValue(inputValue);
    }
  };

  const handleBlurNew: React.FocusEventHandler<HTMLInputElement> = (e) => {
    if (value === '' || value === '-') {
      setValue(0);
    } else {
      const newValue = parseFloat(e.target.value);
      const formattedNewValue = getFormattedValue(newValue);
      setValue(formattedNewValue);
      if (
        previousValueRef.current ===
          row.original[columnMetadata.parent.parent_field] &&
        previousValueRef.current === formattedNewValue
      ) {
        return;
      }
      const rowsData = row.getParentRows().map((data) => data.original);
      if (TableComponent.COGS === componentType) {
        appDispatch(
          handleNumericInputValueChange2({
            columnMetadata,
            newValue: +e.target.value,
            dataRow: row.original,
            changedRows: rowsData,
            uniqueIDColumns,
            depth: row.depth
          })
        );
      } else {
        appDispatch(
          handleNumericInputValueChange({
            columnMetadata,
            newValue: +e.target.value,
            dataRow: row.original,
            changedRows: rowsData,
            uniqueIDColumns,
            depth: row.depth
          })
        );
      }
    }
  };

  const handleBlur: React.FocusEventHandler<HTMLInputElement> = (e) => {
    const formattedNewValue = getFormattedValue(Number(e.target.value));
    setValue(formattedNewValue);
    if (
      previousValueRef.current ===
        row.original[columnMetadata.parent.parent_field] &&
      previousValueRef.current === formattedNewValue
    ) {
      return;
    }
    const rowsData = row.getParentRows().map((data) => data.original);
    if (TableComponent.COGS === componentType) {
      appDispatch(
        handleNumericInputValueChange2({
          columnMetadata,
          newValue: +e.target.value,
          dataRow: row.original,
          changedRows: rowsData,
          uniqueIDColumns,
          depth: row.depth
        })
      );
    } else {
      appDispatch(
        handleNumericInputValueChange({
          columnMetadata,
          newValue: +e.target.value,
          dataRow: row.original,
          changedRows: rowsData,
          uniqueIDColumns,
          depth: row.depth
        })
      );
    }
  };

  useEffect(() => {
    previousValueRef.current = getFormattedValue(
      row.original[columnMetadata.parent.parent_field] as number
    );
  });

  if (value === 0) {
    if (
      kpiSelection === toggle2.name &&
      row.getCanExpand() &&
      componentType !== TableComponent.RENOVATION
    ) {
      return <span>-</span>;
    }
  }
  if (
    kpiSelection === toggle2.name &&
    row.getCanExpand() &&
    componentType !== TableComponent.RENOVATION
  ) {
    return (
      <span>
        {Number.isNaN(value) ? '-' : value}
        {getSuffix()}
      </span>
    );
  }

  return (
    <div className='input-box-container'>
      <input
        value={
          componentType === TableComponent.COGS
            ? value
            : Number.isNaN(value)
            ? '-'
            : value
        }
        onChange={
          componentType === TableComponent.COGS
            ? handleValueChangenew
            : handleValueChange
        }
        onBlur={
          componentType === TableComponent.COGS ? handleBlurNew : handleBlur
        }
        className='table-row-input-box'
        style={{
          paddingRight: columnMetadata.parent.suffix_label ? '10px' : '0px'
        }}
        disabled={
          (componentType=== TableComponent.RENOVATION ||
            componentType === TableComponent.COGS) && 
            inputsDisabled === false ? false :
            row.getCanExpand() || inputsDisabled
        }
        type='number'
        placeholder='-'
        step='0.01'
      />
      <span className='suffix-cell'>{getSuffix()}</span>
    </div>
  );
}
